

























































































































import BaseFormEdit from '../../models/base.form.edit';
import { Component } from 'vue-property-decorator';
import axios from 'axios';
import moment from 'moment';

@Component({})
export default class Edit extends BaseFormEdit {
  form = { destOrganizationId: '', isActive: true, isVirtual: false,
           isForRelatedDonors: false, note: '', groups: [], name: '', address: '', city: '', contacts: '' } as any;

  get createDate() {
    return moment(String(this.form.createDate)).format('DD.MM.YYYY');
  }

  get requiredCode() {
    return this.form.group != 1 ? 'required|' : '';
  }

  get getGroupName() {
    const group = this.form.groups.find((x: any) => x.key === this.form.group);

    return group ? group.value : '';
  }

  organizationChanged() {
    if(this.form.group >= 0) {
      axios
        .get('/Organizations/GetNewOrganizationCode?group=' + this.form.group)
        .then((response) => {
          this.form.code = response.data;
        })
    } else {
      this.form.code ='';
    }
  }

}
